export default [
    {
        path: '/page-not-found',
        name: '404',
        component: () => import('@/apps/web/views/404'),
    },
    {
        path: '/search',
        name: 'search',
        component: () => import('@/apps/web/views/Search'),
    },
    {
        path: '/:keyOne?/:keyTwo?/:keyThree?',
        name: 'resource',
        component: () => import('@/apps/web/views/Resource'),
        props: true,
    },
    {
        path: '/',
        name: 'home',
        component: () => import('@/apps/web/views/Resource'),
    },
];
